import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import Routes from "./Routes";
import { Session } from "@helpers";
import { ConnectService } from '@services';
import { Config } from "@utils";

import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import ReactNotification from "react-notifications-component";
import SessionTimeout from "@components/molecules/SessionTimeout";

import "react-notifications-component/dist/theme.css";

import "react-datepicker/dist/react-datepicker.css";

const browserHistory = createBrowserHistory();

export const SafetyUserContext = React.createContext();

const App = () => {
  const session = React.useContext(Session.SessionContext);
  const [currentSession, setCurrentSession] = React.useState(null);
  const [isSafetyUser, setIsSafetyUser] = React.useState(false);
  const isAuthenticated = localStorage.getItem("user");

  useEffect(() => {
    setCurrentSession(session);
  }, [session]);

  useEffect(() => {
    setIsSafetyUser(isSafetyUser);
  }, [isSafetyUser]);

  const getAppVersion = async() => {
    try {
      const response = await ConnectService.getWebAppVersion('Portal');
      const { appVersion: latestAppVersion } = response.appVersion;
      // console.log(latestAppVersion, Config.currentAppVersion)
      if (latestAppVersion && latestAppVersion !== Config.currentAppVersion) {
        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name);
          });
        });
        localStorage.clear();
        window.location.reload();
      };
    } catch(err) {
      console.error(err);
    }
  }

  useEffect(() => {
    getAppVersion();
  }, []);

  return (
    <>
      <ReactNotification />
      <Session.SessionContext.Provider value={currentSession}>
        <SafetyUserContext.Provider value={{ isSafetyUser, setIsSafetyUser }}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Router history={browserHistory}>
              <Routes />
              <SessionTimeout />
            </Router>
          </MuiPickersUtilsProvider>
        </SafetyUserContext.Provider>
      </Session.SessionContext.Provider>
    </>
  );
};

export default App;
